export const secToMs = (sec: number) => {
  return sec * 1000;
};
